import { refreshTokenExpire } from "./slices/authSlice";

export const customMiddleware =
  (storeAPI: any) => (next: any) => (action: any) => {
    if (action.type.endsWith("/pending")) {
      if (
        action.type.startsWith("check-token/expire") ||
        action.type.startsWith("refresh-token/expire") ||
        action.type.startsWith("account-permission/get") ||
        action.type.startsWith("financial-account-settings/get") ||
        action.type.startsWith("general-settings/get") ||
        action.type.startsWith("get-notification-count/user")
      ) {
        const result = next(action);
        return result;
      }

      const { isTokenRequire, isTokenRefreshing } = storeAPI.getState().auth;

      if (isTokenRequire && !isTokenRefreshing) {
        storeAPI.dispatch(refreshTokenExpire({}));
      }
    }
    return next(action);
  };
